import { render, staticRenderFns } from "./carmonthchangelog.vue?vue&type=template&id=dc90cb0e&"
import script from "./carmonthchangelog.vue?vue&type=script&lang=js&"
export * from "./carmonthchangelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports